var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RollOutRight = exports.RollOutLeft = exports.RollInRight = exports.RollInLeft = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _animationBuilder = require("../animationBuilder");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return (0, _possibleConstructorReturn2.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var _worklet_5864731309735_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{transform:[{translateX:delayFunction(delay,animation(0),config)},{rotate:delayFunction(delay,animation('0deg',config))}]},initialValues:{transform:[{translateX:-values.windowWidth},{rotate:'-180deg'}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Roll.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","transform","translateX","rotate","windowWidth"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Roll.ts"],"mappings":"AAyBW,QAAC,CAAAA,SAAiCA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAE5C,MAAO,CACLC,UAAU,CAAE,CACVC,SAAS,CAAE,CACT,CAAEC,UAAU,CAAET,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAC,CAAEC,MAAM,CAAE,CAAC,CAC1D,CAAEO,MAAM,CAAEV,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,MAAM,CAAEC,MAAM,CAAC,CAAE,CAAC,CAE/D,CAAC,CACDC,aAAa,CAAE,CACbI,SAAS,CAAE,CACT,CAAEC,UAAU,CAAE,CAACV,MAAM,CAACY,WAAY,CAAC,CACnC,CAAED,MAAM,CAAE,SAAU,CAAC,CACtB,CACD,GAAGN,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var RollInLeft = exports.RollInLeft = function(_ComplexAnimationBuil) {
    (0, _inherits2.default)(RollInLeft, _ComplexAnimationBuil);
    var _super = _createSuper(RollInLeft);
    function RollInLeft() {
        var _this;
        (0, _classCallCheck2.default)(this, RollInLeft);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.build = function() {
            var delayFunction = _this.getDelayFunction();
            var _this$getAnimationAnd = _this.getAnimationAndConfig(), _this$getAnimationAnd2 = (0, _slicedToArray2.default)(_this$getAnimationAnd, 2), animation = _this$getAnimationAnd2[0], config = _this$getAnimationAnd2[1];
            var delay = _this.getDelay();
            var callback = _this.callbackV;
            var initialValues = _this.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            transform: [
                                {
                                    translateX: delayFunction(delay, animation(0), config)
                                },
                                {
                                    rotate: delayFunction(delay, animation("0deg", config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            transform: [
                                {
                                    translateX: -values.windowWidth
                                },
                                {
                                    rotate: "-180deg"
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_5864731309735_init_data;
                anonymous.__workletHash = 5864731309735;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this;
    }
    (0, _createClass2.default)(RollInLeft, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new RollInLeft();
            }
        }
    ]);
    return RollInLeft;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_9031884808135_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{transform:[{translateX:delayFunction(delay,animation(0,config))},{rotate:delayFunction(delay,animation('0deg',config))}]},initialValues:{transform:[{translateX:values.windowWidth},{rotate:'180deg'}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Roll.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","transform","translateX","rotate","windowWidth"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Roll.ts"],"mappings":"AAgEW,QAAC,CAAAA,SAAiCA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAE5C,MAAO,CACLC,UAAU,CAAE,CACVC,SAAS,CAAE,CACT,CAAEC,UAAU,CAAET,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC1D,CAAEO,MAAM,CAAEV,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,MAAM,CAAEC,MAAM,CAAC,CAAE,CAAC,CAE/D,CAAC,CACDC,aAAa,CAAE,CACbI,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAEV,MAAM,CAACY,WAAY,CAAC,CAAE,CAAED,MAAM,CAAE,QAAS,CAAC,CAAC,CACrE,GAAGN,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var RollInRight = exports.RollInRight = function(_ComplexAnimationBuil2) {
    (0, _inherits2.default)(RollInRight, _ComplexAnimationBuil2);
    var _super2 = _createSuper(RollInRight);
    function RollInRight() {
        var _this2;
        (0, _classCallCheck2.default)(this, RollInRight);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++){
            args[_key2] = arguments[_key2];
        }
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        _this2.build = function() {
            var delayFunction = _this2.getDelayFunction();
            var _this2$getAnimationAn = _this2.getAnimationAndConfig(), _this2$getAnimationAn2 = (0, _slicedToArray2.default)(_this2$getAnimationAn, 2), animation = _this2$getAnimationAn2[0], config = _this2$getAnimationAn2[1];
            var delay = _this2.getDelay();
            var callback = _this2.callbackV;
            var initialValues = _this2.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            transform: [
                                {
                                    translateX: delayFunction(delay, animation(0, config))
                                },
                                {
                                    rotate: delayFunction(delay, animation("0deg", config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            transform: [
                                {
                                    translateX: values.windowWidth
                                },
                                {
                                    rotate: "180deg"
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_9031884808135_init_data;
                anonymous.__workletHash = 9031884808135;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this2;
    }
    (0, _createClass2.default)(RollInRight, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new RollInRight();
            }
        }
    ]);
    return RollInRight;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_8992545363975_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{transform:[{translateX:delayFunction(delay,animation(-values.windowWidth,config))},{rotate:delayFunction(delay,animation('-180deg',config))}]},initialValues:{transform:[{translateX:0},{rotate:'0deg'}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Roll.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","transform","translateX","windowWidth","rotate"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Roll.ts"],"mappings":"AAoGW,QAAC,CAAAA,SAAiCA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAE5C,MAAO,CACLC,UAAU,CAAE,CACVC,SAAS,CAAE,CACT,CACEC,UAAU,CAAET,aAAa,CACvBC,KAAK,CACLC,SAAS,CAAC,CAACH,MAAM,CAACW,WAAW,CAAEP,MAAM,CACvC,CACF,CAAC,CACD,CAAEQ,MAAM,CAAEX,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,SAAS,CAAEC,MAAM,CAAC,CAAE,CAAC,CAElE,CAAC,CACDC,aAAa,CAAE,CACbI,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAE,CAAE,CAAC,CAAE,CAAEE,MAAM,CAAE,MAAO,CAAC,CAAC,CAClD,GAAGP,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var RollOutLeft = exports.RollOutLeft = function(_ComplexAnimationBuil3) {
    (0, _inherits2.default)(RollOutLeft, _ComplexAnimationBuil3);
    var _super3 = _createSuper(RollOutLeft);
    function RollOutLeft() {
        var _this3;
        (0, _classCallCheck2.default)(this, RollOutLeft);
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++){
            args[_key3] = arguments[_key3];
        }
        _this3 = _super3.call.apply(_super3, [
            this
        ].concat(args));
        _this3.build = function() {
            var delayFunction = _this3.getDelayFunction();
            var _this3$getAnimationAn = _this3.getAnimationAndConfig(), _this3$getAnimationAn2 = (0, _slicedToArray2.default)(_this3$getAnimationAn, 2), animation = _this3$getAnimationAn2[0], config = _this3$getAnimationAn2[1];
            var delay = _this3.getDelay();
            var callback = _this3.callbackV;
            var initialValues = _this3.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            transform: [
                                {
                                    translateX: delayFunction(delay, animation(-values.windowWidth, config))
                                },
                                {
                                    rotate: delayFunction(delay, animation("-180deg", config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            transform: [
                                {
                                    translateX: 0
                                },
                                {
                                    rotate: "0deg"
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_8992545363975_init_data;
                anonymous.__workletHash = 8992545363975;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this3;
    }
    (0, _createClass2.default)(RollOutLeft, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new RollOutLeft();
            }
        }
    ]);
    return RollOutLeft;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_3715386298599_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{transform:[{translateX:delayFunction(delay,animation(values.windowWidth,config))},{rotate:delayFunction(delay,animation('180deg',config))}]},initialValues:{transform:[{translateX:0},{rotate:'0deg'}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Roll.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","transform","translateX","windowWidth","rotate"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Roll.ts"],"mappings":"AA6IW,QAAC,CAAAA,SAAiCA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAE5C,MAAO,CACLC,UAAU,CAAE,CACVC,SAAS,CAAE,CACT,CACEC,UAAU,CAAET,aAAa,CACvBC,KAAK,CACLC,SAAS,CAACH,MAAM,CAACW,WAAW,CAAEP,MAAM,CACtC,CACF,CAAC,CACD,CAAEQ,MAAM,CAAEX,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,QAAQ,CAAEC,MAAM,CAAC,CAAE,CAAC,CAEjE,CAAC,CACDC,aAAa,CAAE,CACbI,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAE,CAAE,CAAC,CAAE,CAAEE,MAAM,CAAE,MAAO,CAAC,CAAC,CAClD,GAAGP,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var RollOutRight = exports.RollOutRight = function(_ComplexAnimationBuil4) {
    (0, _inherits2.default)(RollOutRight, _ComplexAnimationBuil4);
    var _super4 = _createSuper(RollOutRight);
    function RollOutRight() {
        var _this4;
        (0, _classCallCheck2.default)(this, RollOutRight);
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++){
            args[_key4] = arguments[_key4];
        }
        _this4 = _super4.call.apply(_super4, [
            this
        ].concat(args));
        _this4.build = function() {
            var delayFunction = _this4.getDelayFunction();
            var _this4$getAnimationAn = _this4.getAnimationAndConfig(), _this4$getAnimationAn2 = (0, _slicedToArray2.default)(_this4$getAnimationAn, 2), animation = _this4$getAnimationAn2[0], config = _this4$getAnimationAn2[1];
            var delay = _this4.getDelay();
            var callback = _this4.callbackV;
            var initialValues = _this4.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            transform: [
                                {
                                    translateX: delayFunction(delay, animation(values.windowWidth, config))
                                },
                                {
                                    rotate: delayFunction(delay, animation("180deg", config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            transform: [
                                {
                                    translateX: 0
                                },
                                {
                                    rotate: "0deg"
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_3715386298599_init_data;
                anonymous.__workletHash = 3715386298599;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this4;
    }
    (0, _createClass2.default)(RollOutRight, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new RollOutRight();
            }
        }
    ]);
    return RollOutRight;
}(_animationBuilder.ComplexAnimationBuilder);
